export default __webpack_public_path__ + "static/media/DangerIcon.91ee90c8.png";